import type { SVGProps } from 'react';

const SvgXMarkBullet = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M16 32c8.84 0 16-7.16 16-16S24.84 0 16 0 0 7.16 0 16s7.16 16 16 16m-2.59-21.41c-.78-.78-2.05-.78-2.83 0s-.78 2.05 0 2.83l2.59 2.59-2.59 2.59c-.78.78-.78 2.05 0 2.83s2.05.78 2.83 0L16 18.84l2.59 2.59c.78.78 2.05.78 2.83 0s.78-2.05 0-2.83l-2.59-2.59 2.59-2.59c.78-.78.78-2.05 0-2.83s-2.05-.78-2.83 0L16 13.18z"
    />
  </svg>
);

export default SvgXMarkBullet;
